import { DateTime } from "util/time";

export enum ContentPageItemType {
  Text = "text",
  HTML = "html",
  Image = "image",
  List = "list",
  Object = "object",
}

export type ContentPageItem =
  | string
  | URL
  | ContentPageItem[]
  | ContentPageItemCollection;
export type ContentPageItemCollection = { [index: string]: ContentPageItem };

export interface ContentPage {
  name: string;
  url: string;
  pageTitle: string | null;
  metaDescription: string | null;
  items: ContentPageItemCollection;
  pageType: string | null;
}

export interface Article {
  source: string | null;
  title: string;
  date: DateTime;
  heroImage: URL | null;
  url: URL;
}

export interface Award {
  name: string | null;
  description: string;
  date: DateTime;
  logo: URL | null;
  url: URL;
}

export interface ReportRequest {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  company: string;
}

export interface BlogPost {
  code: string;
  title: string;
  blurb: string;
  published: DateTime;
  heroImage: URL | null;
  url: URL | null;
  hasReport: boolean;
  content: BlogPostContent | null;
  highlighted: string | null;
  short_title: string | null;
}

export interface BlogPostContent {
  headline: string;
  subheadline: string | null;
  title: string | null;
  bodyTop: string | null;
  bodyBottom: string | null;
  quote: BlogPostQuote | null;
  images: URL[];
}

export interface BlogPostQuote {
  text: string;
  customerName: string | null;
  customerCompany: string | null;
}

export interface Testimonial {
  name: string;
  company: string;
  quote: string;
  heroImage: URL | null;
}

export interface SpaceHighlightSpace {
  code: string;
  name: string;
}

export interface SpaceHighlight {
  space: SpaceHighlightSpace;
  title: string;
  subtitle: string;
  heroImage: URL;
}

export interface SuccessStory {
  name: string;
  company: string;
  quote: string;
  heroImage: URL;
}
export enum ImageType {
  Banner = "banner",
  Gallery = "gallery",
}

export interface Image {
  url: string;
  type?: ImageType;
}

export interface Link {
  url?: string | any;
  label?: string | any;
}

export interface DynamicImageSizes {
  sm?: string;
  md?: string;
  lg?: string;
  xl: string;
}

export interface Stat {
  id?: number;
  title?: string;
  subtitle?: string;
  unit?: number;
  prefix?: string;
  suffix?: string;
}

export interface BackgroundAssetPosition {
  top?: string | any;
  right?: string | any;
  bottom?: string | any;
  left?: string | any;
}

export interface TabNav {
  code?: string;
  label: string;
  value: string;
  backgroundAsset?: string;
  backgroundAssetPosition?: BackgroundAssetPosition;
}
